import { render, staticRenderFns } from "./hole-sponsors.vue?vue&type=template&id=88138214&scoped=true"
import script from "./hole-sponsors.vue?vue&type=script&lang=js"
export * from "./hole-sponsors.vue?vue&type=script&lang=js"
import style0 from "./hole-sponsors.vue?vue&type=style&index=0&id=88138214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88138214",
  null
  
)

export default component.exports